import { render } from "./AdicionarActivos.vue?vue&type=template&id=500834f8"
import script from "./AdicionarActivos.vue?vue&type=script&lang=js"
export * from "./AdicionarActivos.vue?vue&type=script&lang=js"

import "./AdicionarActivos.vue?vue&type=style&index=0&id=500834f8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__